class Extranet.Model extends Backbone.Model
  idAttribute: 'uuid'

  sync: (method, model, options) ->
    if method is "patch"
      method = "update"
    Backbone.Model.prototype.sync method, model, options
